const initBookingProcessButtons = () => {
    const bookingResultItemButtons = document.getElementsByClassName('booking-process-spin-button');
    Array.from(bookingResultItemButtons).forEach(button => {
        button.addEventListener('click', () => {
            button.classList.add('--spinning');
        });
        return true;
    });

    const bookingProcessSpinForms = document.getElementsByClassName('booking-process-spinner-form');
    Array.from(bookingProcessSpinForms).forEach(form => {

        form.addEventListener('submit', () => {
            const buttons = form.getElementsByClassName('booking-process-spin-button__in-form');
            Array.from(buttons).forEach(button => {
                button.classList.add('--spinning');
                return true;
            });
        });
        return true;
    });

};

export default initBookingProcessButtons;
